// modules/website/components/ButtonComponent.tsx - Botão CTA Standalone

import React from 'react';
import { ButtonData } from '@/types';

interface Props {
  data: ButtonData;
  settings?: any;
}

export const ButtonComponent: React.FC<Props> = ({ data, settings }) => {
  const {
    text = 'Clique aqui',
    link = '#',
    style = 'primary',
    size = 'medium',
    icon,
    iconPosition = 'left',
    openInNewTab = false,
    animation = 'none'
  } = data || {};

  // Classes de estilo
  const styleClasses = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 shadow-lg hover:shadow-xl',
    secondary: 'bg-gray-800 text-white hover:bg-gray-900 shadow-lg',
    outline: 'border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white',
    whatsapp: 'bg-green-500 text-white hover:bg-green-600 shadow-lg'
  };

  // Classes de tamanho
  const sizeClasses = {
    small: 'px-4 py-2 text-sm',
    medium: 'px-6 py-3 text-base',
    large: 'px-8 py-4 text-lg'
  };

  // Classes de animação
  const animationClasses = {
    none: '',
    pulse: 'animate-pulse',
    bounce: 'hover:animate-bounce'
  };

  // Ícones embutidos
  const icons: Record<string, string> = {
    whatsapp: '📱',
    phone: '📞',
    email: '✉️',
    arrow: '→',
    fish: '🎣',
    calendar: '📅',
    star: '⭐'
  };

  const iconEmoji = icon ? (icons[icon] || icon) : (style === 'whatsapp' ? '📱' : undefined);

  return (
    <div 
      className="py-6 text-center"
      style={{ backgroundColor: settings?.backgroundColor }}
    >
      <a
        href={link}
        target={openInNewTab ? '_blank' : undefined}
        rel={openInNewTab ? 'noopener noreferrer' : undefined}
        className={`
          inline-flex items-center gap-2 rounded-lg font-semibold
          transition-all duration-300 transform hover:scale-105
          ${styleClasses[style]}
          ${sizeClasses[size]}
          ${animationClasses[animation]}
        `}
      >
        {iconEmoji && iconPosition === 'left' && <span>{iconEmoji}</span>}
        {text}
        {iconEmoji && iconPosition === 'right' && <span>{iconEmoji}</span>}
      </a>
    </div>
  );
};
